import { MembershipCategory } from 'utils/types/membershipSkus';
import { getCategoryMap } from 'utils/helpers/membershipSkuHelper';
import chlamydiaGonorrhea from 'images/kits/chlamydia-gonorrhea-box@2x.png';
import cholesterolLipids from 'images/kits/cholesterol-lipids-box@2x.png';
import bdVeritorTest from 'images/kits/DTC_Image_Cart_DBVeritor_COVIDTest.png';
import fitRectalCancer from 'images/kits/fit-colorectal-cancer-box@2x.png';
import hba1c from 'images/kits/hb-a-1-c-box@2x.png';
import heartHealth from 'images/kits/heart-health-box@2x.png';
import hepatitisC from 'images/kits/hepatitis-c-box@2x.png';
import hiv from 'images/kits/hiv-box@2x.png';
import hpv from 'images/kits/hpv-box@2x.png';
import metabolism from 'images/kits/metabolism-box@2x.png';
import syphilis from 'images/kits/syphilis-box@2x.png';
import testosterone from 'images/kits/testosterone-box@2x.png';
import thyroid from 'images/kits/thyroid-box@2x.png';
import trichomoniasis from 'images/kits/trichomoniasis-box@2x.png';
import vitaD from 'images/kits/v-itamin-d-box@2x.png';
import vitaDInflammation from 'images/kits/vitamin-d-inflammation-box@2x.png';

const imageList = [
  chlamydiaGonorrhea,
  cholesterolLipids,
  bdVeritorTest,
  fitRectalCancer,
  hba1c,
  heartHealth,
  hepatitisC,
  hiv,
  hpv,
  metabolism,
  syphilis,
  testosterone,
  thyroid,
  trichomoniasis,
  vitaD,
  vitaDInflammation,
];

export const categoryProductSKUMap: Record<string, MembershipCategory> = {
  ...getCategoryMap(imageList),
};
